/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    parts: [
        'container',
        'content',
        'subscribe',
        'subscribeField',
        'subscribeButtonContainer',
        'subscribeHeading',
        'subscribeMessage',
        'localeSelector',
        'bottomHalf',
        'horizontalRule',
        'socialIcons',
        'localeDropdown',
        'localeDropdownOption',
        'divider',
        'languageLink',
        'languageLinkIcon'
    ],
    baseStyle: ({theme}) => ({
        container: {
            width: 'full',
            background: 'stokkeGray.mid'
        },
        content: {
            boxing: {
                maxWidth: 'container.xxl',
                marginLeft: 'auto',
                marginRight: 'auto'
            },
            color: 'white',
            paddingTop: {base: 8, lg: 10}
        },
        subscribe: {
            maxWidth: {base: '21.5rem', lg: 'none'}
        },
        subscribeField: {
            background: 'white',
            color: 'gray.900'
        },
        subscribeButtonContainer: {
            width: 'auto'
        },
        subscribeHeading: {
            fontSize: 'md',
            marginBottom: 2
        },
        subscribeMessage: {
            fontSize: 'sm',
            marginBottom: 4
        },
        localeSelector: {
            display: 'inline-block',
            marginTop: 8
        },
        localeDropdown: {
            background: 'gray.800',
            _hover: {
                background: 'whiteAlpha.500'
            }
        },
        localeDropdownOption: {
            color: 'black'
        },
        bottomHalf: {
            width: '100%',
            textAlign: 'center'
        },
        horizontalRule: {
            container: {
                marginTop: 6,
                marginBottom: 6
            },
            divider: {
                borderColor: 'stokkeGray.mid'
            }
        },
        languageLink: {
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            ...theme.textStyles['Regular Small']
        },
        languageLinkIcon: {
            width: 4,
            height: 4
        }
    })
}
